import MapContainerEmergency from './MapContainerEmergency';

export default MapContainerEmergency;
